import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { LiveOrderDetailsData } from '../../models/LiveOrderProductProps';

const LIVE_ORDER = 'api/v1/bc-orders';

const useLiveOrderDetailsSWR = (liveOrderId: string) => {
    const fetchUser = (query): Promise<LiveOrderDetailsData[]> => {
        return httpApi
            .get<{ order: LiveOrderDetailsData[] }>(query)
            .then((res) => {
                return res.getData().order;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        LIVE_ORDER + '/' + liveOrderId,
        fetchUser,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        order: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useLiveOrderDetailsSWR;
